// Custom hook to use the clipboard
// Path: hooks\use-copy-to-clipboard.tsx
// Compare this snippet from components\marketplace\wallet\charge-wallet-modal.tsx:
// Usage:
// const [value, copy] = useCopyToClipboard();
//

import { useState } from 'react';
import { sentryCaptureException } from '~/errors/sentry';

type CopiedValue = string | any;
type CopyFn = (text: string) => Promise<boolean>;

const useCopyToClipboard = () => {
   const [copiedText, setCopiedText] = useState<CopiedValue>(null);

   const copy: CopyFn = async text => {
      if (!navigator?.clipboard) {
         console.warn('Clipboard not supported');
         sentryCaptureException('Clipboard not supported');
         return false;
      }

      try {
         await navigator.clipboard.writeText(text);
         setCopiedText(text);
         return true;
      } catch (error) {
         console.warn('Copy failed', error);
         sentryCaptureException(error);
         setCopiedText(null);
         return false;
      }
   };

   return [copiedText, copy];
};

export default useCopyToClipboard;
